import { Css, RichTextField, useModal, useSnackbar } from "@homebound/beam";
import { useState } from "react";
import { VersionableFragment } from "src/components/ReadyPlanVersionHeader.generated";
import { AggregateVersionStatus } from "src/generated/graphqlTypes";
import { ConfirmationModal } from "src/routes/components/ConfirmationModal";
import { useSaveReadyPlanAggregateVersionMutation } from "./PublishAggregateVersionModal.generated";
type PublishAggregateVersionModalProps = {
  copyText: string;
  draftAggregateVersion: VersionableFragment;
  readyPlanName: string;
};

export function PublishAggregateVersionModal(props: PublishAggregateVersionModalProps) {
  const { copyText, draftAggregateVersion, readyPlanName } = props;
  const { closeModal } = useModal();
  const { triggerNotice } = useSnackbar();
  const [versionNotes, setVersionNotes] = useState<string | undefined>();
  const [save] = useSaveReadyPlanAggregateVersionMutation();

  const { version } = draftAggregateVersion ?? {};

  async function publishPlanPackage() {
    await save({
      variables: { input: { id: draftAggregateVersion.id, status: AggregateVersionStatus.Active, versionNotes } },
    });
    triggerNotice({
      message: (
        <>
          v{version} of <span css={Css.tdu.$}>{readyPlanName}</span> has been published.
        </>
      ),
    });
    closeModal();
  }

  return (
    <ConfirmationModal
      title={`Ready to Publish v${version}?`}
      label="Publish"
      onConfirmAction={() => publishPlanPackage()}
      confirmationMessage={
        <div css={Css.df.fdc.gap2.$}>
          <p>{copyText}</p>
          <RichTextField label="Version Notes" value={versionNotes} onChange={(val) => setVersionNotes(val)} />
        </div>
      }
    />
  );
}
